export const MAX_DOCUMENTS_COUNT = 10
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024

export const MAX_FILE_SIZE_BYTES_CUSTOMER = 1 * 1024 * 1024

export const ALLOWED_CUSTOMER_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpeg',
]

// Расширения-фолбэк: ОС не всегда сопоставляет расширение mime-типу
// (частый случай — .docx без установленного MS Office), тогда file.type пустой
export const ALLOWED_CUSTOMER_EXTENSIONS = ['pdf', 'docx', 'png', 'jpg', 'jpeg']

export const ALLOWED_CUSTOMER_FORMATS = [
  ...ALLOWED_CUSTOMER_EXTENSIONS.map(extension => `.${extension}`),
  ...ALLOWED_CUSTOMER_MIME_TYPES,
].join(',')

export const FORBIDDEN_VIDEO_TYPES = [
  'video/mpeg',
  'video/mp4',
  'video/ogg',
  'video/quicktime',
  'video/webm',
  'video/x-ms-wmv',
  'video/x-flv',
  'video/3gpp',
  'video/3gpp2',
  'video/x-ms-asf',
  'video/x-msvideo',
  'video/x-matroska',
  'video/x-ms-wmx',
  'video/x-ms-wm',
  'video/avi',
  'video/divx',
]
